import type { HTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

type SkeletonProps = HTMLAttributes<HTMLDivElement>;

export function Skeleton({ className, ...props }: SkeletonProps) {
  return (
    <div
      className={cn(
        'animate-pulse rounded-md bg-surface-container-high',
        className,
      )}
      {...props}
    />
  );
}
